import { render, staticRenderFns } from "./AddAccommodationForm.vue?vue&type=template&id=372d64f9&"
import script from "./AddAccommodationForm.vue?vue&type=script&lang=js&"
export * from "./AddAccommodationForm.vue?vue&type=script&lang=js&"
import style0 from "./AddAccommodationForm.vue?vue&type=style&index=0&id=372d64f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports